import { render, staticRenderFns } from "./ListadoMontosComisiones.vue?vue&type=template&id=16cc994d"
import script from "./ListadoMontosComisiones.vue?vue&type=script&lang=js"
export * from "./ListadoMontosComisiones.vue?vue&type=script&lang=js"
import style0 from "./ListadoMontosComisiones.vue?vue&type=style&index=0&id=16cc994d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports